import React, { Component } from "react";
import "../modules/center.css";
import { getMenu } from "../modules/helpers";

import { IconButton } from "@fluentui/react/lib/Button";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Tooltip } from "antd";
import { ChevronLeft } from "react-feather";
import renderHTML from "react-render-html";

function FullscreenAdapter({ onChange, className, children }) {
  const handle = useFullScreenHandle();

  const toggleFullscreen = () => {
    const fullscreenAction = handle.active ? handle.exit() : handle.enter();

    if (fullscreenAction?.catch) {
      fullscreenAction.catch(() => onChange(false));
    }
  };

  return (
    <FullScreen handle={handle} onChange={onChange} className={className}>
      {children({ isFull: handle.active, toggleFullscreen })}
    </FullScreen>
  );
}

function PageHeaderAdapter({ className, onBack, title, backIcon, subTitle }) {
  return (
    <div className={className} style={{ display: "flex", alignItems: "center" }}>
      <button
        type="button"
        onClick={onBack}
        aria-label="Go back"
        style={{ border: 0, background: "transparent", padding: 0, cursor: "pointer" }}
      >
        {backIcon}
      </button>
      <div>
        <div>{title}</div>
        {subTitle && <div>{subTitle}</div>}
      </div>
    </div>
  );
}

export function PageContainerHOC(WrappedComponent, data) {
  return class extends Component {
    state = {
      isFull: false,
    };
    render() {
      const menu = getMenu(this.props.match.url);
      return (
        <FullscreenAdapter
          onChange={(isFull) => {
            this.setState({ isFull });
          }}
          className="ms-Grid-col ms-sm12"
        >
          {({ toggleFullscreen }) => <div className="ms-Grid qikreach-page-container" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                  <div
                    className="ms-Grid-col ms-sm9"
                    style={{ paddingTop: "10px" }}
                  >
                    <PageHeaderAdapter
                      className="site-page-header"
                      onBack={() => {
                        this.props.history.goBack();
                      }}
                      title={renderHTML(menu)}
                      /*  subTitle="This is a subtitle" */
                      backIcon={
                        <Tooltip title="go back">
                          <ChevronLeft
                            style={{ marginTop: "5px", color: "red" }}
                          />
                        </Tooltip>
                      }
                    />
                  </div>

                  <div
                    className="ms-Grid-col ms-sm1"
                    style={{
                      textAlign: "right",
                      width: "50px",
                      paddingTop: "10px",
                    }}
                  ></div>
                  <div
                    className="ms-Grid-col ms-sm1"
                    style={{
                      textAlign: "right",
                      width: "50px",
                      paddingTop: "10px",
                    }}
                  >
                    <Tooltip title="View fullscreen">
                      <IconButton
                        iconProps={{ iconName: "FullScreen" }}
                        ariaLabel="FullScreen"
                        onClick={toggleFullscreen}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="ms-Grid-col ms-sm12 "
              id="outer"
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minHeight: 0,
              }}
            >
              <WrappedComponent
                data={{ ...this.props, ...data }}
                id="inner"
                className="ms-depth-4"
              />
            </div>
          </div>}
        </FullscreenAdapter>
      );
    }

    _onSettingsDismiss = () => {
      this.setState({ showSettings: false });
    };
  };
}

